import { css } from '@leafygreen-ui/emotion';

export const subtitleStyles = css`
  font-size: 18px;
  line-height: 24px;
  font-weight: 700;
`;
